export default {
  contact_provider: 'Veuillez contacter votre prestataire pour activer cette fonctionnalité.',
};
